import React from "react";
import { motion } from "framer-motion";
import "./About.css";

function AboutUs() {
  return (
    <section id="about" className="about">
      <motion.div
        className="about-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2>About Me</h2>
        <p>
          Hey, I’m <span className="highlight">Manish</span> — a creative
          <span className="highlight"> Frontend Developer</span> with solid skills in
          <span className="highlight"> full-stack development</span>. While I mainly focus on crafting
          smooth, user-friendly frontend experiences, I also enjoy working on backend integration
          and building complete solutions.
        </p>
        <p>
          I thrive in leading projects, brainstorming innovative ideas, and collaborating with
          teams to bring concepts to life. My toolkit includes React, Node.js, Figma, and automation
          tools that streamline workflows and improve productivity.
        </p>
        <p>
          For me, work is about balancing creativity and technology in a way that’s both fun and
          fulfilling. I’m passionate about continuous learning and excited to tackle challenges
          that push my skills further.
        </p>
        <a href="#contact" className="btn-primary">Let’s Connect</a>
      </motion.div>
    </section>
  );
}

export default AboutUs;
